<template>
<el-container>
  <el-main>
    <el-card class="box-card">
     <div slot="header" class="clearfix">
        <el-link icon="el-icon-back" type="success" @click="back">{{$t('checkInMoreRoom.back')}}</el-link>
        <!-- <span>授权选项</span> -->
        <el-button type="primary" style="float:right;margin-top:-5px" @click="confirmChooseUser">{{$t('checkInMoreRoom.batchAuth')}}</el-button>
     </div>
     <el-form :inline="true" :model="addAutoForm" ref="selectForm" class="demo-ruleForm" style="margin-top:10px">
     
       <el-form-item :label="$t('checkInMoreRoom.authType')" style="width:500px">
            <el-radio v-model="addAutoForm.validType" label="0">{{$t('checkInMoreRoom.password')}}</el-radio>
            <el-radio v-model="addAutoForm.validType" label="1">{{$t('checkInMoreRoom.doorCard')}}</el-radio>
            <el-radio v-model="addAutoForm.validType" label="2">{{$t('checkInMoreRoom.idCard')}}</el-radio>
            <el-radio v-model="addAutoForm.validType" label="3">{{$t('checkInMoreRoom.fingerprint')}}</el-radio>
       </el-form-item>  
       </br> 
       <el-form-item :label="$t('checkInMoreRoom.authContent')" style="width:400px" v-show="addAutoForm.validType==0">
           <el-input v-model="addAutoForm.validData" :placeholder="$t('checkInMoreRoom.createsjpassword')"></el-input>
       </el-form-item>   
       <el-form-item :label="$t('checkInMoreRoom.time')">
         <div class="block">
           <el-date-picker
           v-model="addAutoForm.beginTime"
           type="datetime"
           :disabled="addAutoForm.beginFlag"
           :placeholder="$t('checkInMoreRoom.chooseBeginTime')">
           </el-date-picker>
         </div>
       </el-form-item>  
       <el-form-item label="-">
         <div class="block">
           <el-date-picker
           v-model="addAutoForm.endTime"
           type="datetime"
           :disabled="addAutoForm.endFlag"
           :placeholder="$t('checkInMoreRoom.chooseEndTime')">
           </el-date-picker>
         </div>
       </el-form-item>
     </el-form>    

    </el-card>
  
    <!-- 租客列表 -->
    <el-card class="box-card">
    <div slot="header" class="clearfix">
        <span>
        <el-input style="width:280px" type="text" v-model="tenantSelectForm.tenantName" :placeholder="$t('checkInMoreRoom.moreTenantNameSelectMsg')"></el-input>
        <el-button type="primary"  @click="tenantOnSelect">{{$t('checkInMoreRoom.search')}}</el-button>
        </span>
    </div>
    <el-table
    :data="pageData.userData"
    :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    empty-text="No Data"
    border
    style="margin-top: 5px"
    @selection-change="handleSelectionChange"
    >

    <el-table-column
      type="selection"
      width="55">
    </el-table-column>

    <el-table-column
    prop="tenantName"
    :label="$t('checkInMoreRoom.tenantName')">
    </el-table-column>

    <el-table-column
    prop="tenantIdentityId"
    :label="$t('checkInMoreRoom.idCard')">
    </el-table-column>

    <el-table-column
    prop="tenantPhone"
    :label="$t('checkInMoreRoom.phone')">
    </el-table-column>
    
    <el-table-column
    prop="tenantEmail"
    :label="$t('checkInMoreRoom.email')">
    </el-table-column>

    <el-table-column
    prop="cardNo"
    :label="$t('checkInMoreRoom.cardNo')">
    </el-table-column>

    <el-table-column
    prop="fingerType"
    width="100"
    :label="$t('checkInMoreRoom.fingerprintType')">
      <template slot-scope="scope">
          {{scope.row.fingerType==0?$t('checkInMoreRoom.undefined'):scope.row.fingerType==1?$t('checkInMoreRoom.leftThumb'):scope.row.fingerType==2?$t('checkInMoreRoom.leftIndexFinger'):scope.row.fingerType==3?$t('checkInMoreRoom.leftHandMiddleFinger'):scope.row.fingerType==4?$t('checkInMoreRoom.ringFingerOfLeftHand'):scope.row.fingerType==5?$t('checkInMoreRoom.leftTailToRefer'):
          scope.row.fingerType==6?$t('checkInMoreRoom.rightThumb'):scope.row.fingerType==7?$t('checkInMoreRoom.rightIndexFinger'):scope.row.fingerType==8?$t('checkInMoreRoom.rightHandMiddleFinger'):scope.row.fingerType==9?$t('checkInMoreRoom.ringFingerOfRightHand'):scope.row.fingerType==10?$t('checkInMoreRoom.rightTailToRefer'):""}}
      </template>  
    </el-table-column>

    <el-table-column prop="checkInRoomNames" min-width="120" :label="$t('update.checkInRoom')" align="center">
        <template slot-scope="scope">
          {{roomListShow(scope.row.checkInRoomNames)}}
        </template>  
    </el-table-column>

    <el-table-column
    prop="createTime"
    :formatter="this.$util.datetimeFormat"
    :label="$t('checkInMoreRoom.createTime')">
    </el-table-column>

    </el-table>

    <el-footer>
      <div>
        <Pagings
        :total="pageData.total"
        :offset="pageData.offset"
        :pageSize="pageData.pageNumber"
        @handleSizeChangeSub="tenantHandleSizeChange"
        @handleCurrentChangeSub="tenantHandleCurrentChange">
        </Pagings>
      </div>
    </el-footer> 
    </el-card>
  
  </el-main>
</el-container>  
</template>

<script>
import Pagings from "../common/Pagings.vue";
export default {
   data() {
     return {
       addAutoForm:{
          beginTime:"",
          endTime:"",
          isLimit:0,
          isLocked:0,
          isOpen:0,
          apartmentId:this.$route.query.apartmentId,
          roomId:this.$route.query.roomId,
          userInfoList:[],
          validType:'0',
          validData:"",
          beginFlag:false,
          endFlag:false,
          roomData:""
       },
       pageData:{
         offset: 1,
         pageNumber: 10,
         total: 0, //总条数
         userData: [],
        },  
        multipleSelection: [],
        tenantSelectForm:{
          tenantName:""
        }
     }
   },
   components: {
    Pagings
   },
   mounted() {
      this.getTenantPage();
      this.getRoomDetail();
   }, 
   methods: {
    back(){
      
      this.$router.push({path:"/roomList",query: {apartmentId:this.addAutoForm.apartmentId}});
    //  this.$router.back(-1);
    },
    tenantOnSelect(){
      this.getTenantPage();
    },
    confirmChooseUser(){
        if(this.multipleSelection==""||this.multipleSelection.length==0){
          this.$message({
            message:this.$t('checkInMoreRoom.chooseAuthTenant'),
            type: "warning"
          });
          return false
        }
        
        var formData = new FormData();
        if(this.addAutoForm.beginTime!=""&&this.addAutoForm.endTime!=""){
          //时间不是空的时候为临时密码
          formData.append("isLimit",1);
          formData.append("beginTime",this.$util.formartDateTime(this.addAutoForm.beginTime));
          formData.append("endTime",this.$util.formartDateTime(this.addAutoForm.endTime));
          formData.append("validUser ",2);//临时用户
        }else{
          this.$message({
            message:this.$t('checkInMoreRoom.chooseCheckInTime'),
            type: "warning"
          });
          return false;
          //时间空的时候为永久密码
          // formData.append("isLimit",0);  
          // formData.append("validUser ",1);//普通用户
        }
        formData.append("userInfoList",JSON.stringify(this.jxUserData()));//huo
        formData.append("validType",this.addAutoForm.validType);
        formData.append("validData",this.addAutoForm.validData);
        formData.append("isLocked",0);
        formData.append("isOpen",0);
        formData.append("roomId",this.addAutoForm.roomId);
        formData.append("validDataIsExist",1);
        
      this.$server
      .exam("/customer/room/roomCheckIn", formData)
      .then(data => {
        if (data.code == 200) {
          this.$message({
            message:this.$t('checkInMoreRoom.authSuccess'),
            type: "success"
          });
          this.addAutoForm.beginFlag=true,
          this.addAutoForm.endFlag=true,
          this.getTenantPage();
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
        
    },

     //分解入住房间列表
    roomListShow(data){
      var rtn="";
      if(data!=null&&data!=""){
        for(var str in data){
         rtn+=data[str]+",";
        }
        rtn=rtn.substring(0,rtn.length-1);
      }
       return rtn;
    },
    
    jxUserData(){
        var rtnData=[];
        var tenantData=this.multipleSelection;
          for(var i=0;i<tenantData.length;i++){
             var obj={};
             obj.associatedUserId=tenantData[i].tenantId;
             obj.userType=0;
             obj.userName=tenantData[i].tenantName;
             rtnData.push(obj);
        }
        return rtnData;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    getTenantPage(){
      var formData = new FormData();
      if(this.tenantSelectForm.tenantName!=""&&this.tenantSelectForm.tenantName!=null){
         formData.append("tenantName",this.tenantSelectForm.tenantName);
      }
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      this.$server
      .exam("/customer/tenant/listTenant", formData)
      .then(data => {
        if (data.code == 200) {
          this.pageData.userData=data.data.records;
          this.pageData.total = data.data.total;          
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    }, 

    getRoomDetail(){
      var formData = new FormData();
      formData.append("roomId",this.addAutoForm.roomId);
      this.$server
      .exam("/customer/room/getRoomDetail", formData)
      .then(data => {
        if (data.code == 200) {
          this.addAutoForm.roomData=data.data;    
          if(data.data.status==0){
            this.addAutoForm.beginFlag=false;
            this.addAutoForm.endFlag=false;
            this.addAutoForm.beginTime=new Date().getTime();
            var dateTime=new Date();
            this.addAutoForm.endTime=new Date(dateTime.setDate(dateTime.getDate() + 1)).getTime();
          }else{
            this.addAutoForm.beginTime=data.data.beginTime;
            this.addAutoForm.endTime=data.data.endTime;
            this.addAutoForm.beginFlag=true;
            this.addAutoForm.endFlag=true;
          }    
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    }, 

    tenantHandleSizeChange(val) {
       this.pageData.pageNumber = val;
       this.getTenantPage();
     },
    tenantHandleCurrentChange(val) {
       this.pageData.offset = val;
       this.getTenantPage();
     },
   }           
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/room/checkInMoreRoom.vue